angular.module('salesPath2')
  .controller('apkRenewalModalCtrl', ['$scope', 'apkErrorsHelper', 'apkRestSvc', 'sp2UiHelper', 'dataContainerHelper', '$window',
    function($scope, apkErrorsHelper, apkRestSvc, sp2UiHelper, dataContainerHelper, $window) {

      /**
      * init
      */
      $scope.init = function() {        
        $scope.fireListeners();
      };

      /**
       * Odpalenie watchy
       */
      $scope.fireListeners = function() {
        // continue
        $scope.$on('iHestiaCommonModalOkBtnClicked.apkRenewalModal', function() {
          apkErrorsHelper.renewPolicy();
        });

        // refresh
        $scope.$on('iHestiaCommonModalCancelBtnClicked.apkRenewalModal', function() {
          $window.open(apkErrorsHelper.portalUrl, '_self');
        });
      };

      $scope.init();

    }
  ]);
